import React, { useEffect, useState } from 'react';
import apiUrls from '../api/apiUrls';
import fetchWithAuth from '../api/fetchWithAuth';
import BookShelf from './Bookshelf';
import Loader from './Loader';

/* Importar Slick */
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const Bookcase = () => {

  const [bookshelves, setBookshelves] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookshelves = async () => {
      try {
        let response;
        // Si hay un token en localStorage (o similar), intentamos fetchWithAuth
        // De lo contrario, un fetch normal al endpoint ahora público
        const token = localStorage.getItem('token'); // Asumiendo que se guarda aquí o usamos AuthContext
        
        if (token) {
          response = await fetchWithAuth(apiUrls.mostPopularShelfApi);
        } else {
          response = await fetch(apiUrls.mostPopularShelfApi);
        }
        
        const json = await response.json();
        setBookshelves(json.data.bookshelf);
      } catch (err) {
        console.error('Error al cargar datos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBookshelves();
  }, []);

  if (loading) return <Loader visible={loading}/>;

  return (
    <div className="bookcase" id="homeContainer">
      {Object.entries(bookshelves).map(([label, books]) => (
        <BookShelf key={label} label={label} books={books} />
      ))}
    </div>
  );
};

export default Bookcase;
